import { RoutesService, eLayoutType } from '@abp/ng.core';
import { inject, provideAppInitializer } from '@angular/core';

export const APP_ROUTE_PROVIDER = [
  provideAppInitializer(() => {
    configureRoutes();
  }),
];

function configureRoutes() {
  const routes = inject(RoutesService);
  routes.add([
    {
      path: '/',
      name: '::Menu:Home',
      iconClass: 'fas fa-home',
      order: 1,
      layout: eLayoutType.application,
    },
    {
      path: '/dashboard',
      name: '::Menu:Dashboard',
      iconClass: 'fas fa-chart-line',
      order: 2,
      layout: eLayoutType.application,
      requiredPolicy: 'SelfServePortal.Dashboard.Host  || SelfServePortal.Dashboard.Tenant',
    },
     {
      path: '/faculty-profile',
      name: 'Faculty Profile',
      iconClass: 'fas fa-user-tie',
      order: 4,
      layout: eLayoutType.application,
      // requiredPolicy: 'SelfServePortal.FacultyProfile', // Temporarily commented out for testing
    },
    {
      path: '/faculty-management',
      name: 'Faculty Management',
      iconClass: 'fas fa-chalkboard-teacher',
      order: 5,
      layout: eLayoutType.application,
      requiredPolicy: 'SelfServePortal.FacultyManagement',
    },
    {
      path: '/affiliations-management',
      name: 'Affiliations Management',
      iconClass: 'fas fa-handshake',
      order: 6,
      layout: eLayoutType.application,
      requiredPolicy: 'SelfServePortal.AffiliationsManagement',
    },
    {
      path: '/events-management',
      name: 'Events Management',
      iconClass: 'fas fa-calendar',
      order: 7,
      layout: eLayoutType.application,
    }
  ]);
}
